import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';


import Otp from './otp';

import * as ROUTES from 'constants/routes';

import LOGO from 'assets/images/login/logo.svg';
import CHARTS from 'assets/gifs/login/charts.gif';

import Phone from './phone';

import styles from './content.module.scss';
import RestServices from '../services/RestServices.js';
function Content({ history }) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [otpSuccess, setOtpSuccess] = useState('');
    const [phone, setPhone] = useState('');
    const [renderOtpScreen, setRenderOtpScreen] = useState(false);
    const logoResize =
        window.screen.width / 1400 > 1 ? 1 : window.screen.width / 1400;

    

   
    function handleGetOtp(phone) {
         setLoading(true);
        try {
            let dataRow = {
                PhoneNumber: '+91' + phone
            };
            RestServices.validatePhone(dataRow)
                .then((response) => response.json())
                .then(async (responseData) => {
                    if(responseData.status){
                        setPhone(phone)
                        setRenderOtpScreen(true);
                        setLoading(false);
                        setOtpSuccess(responseData.message);
                        setError('');
                    }else{
                        setLoading(false);
                        setError(responseData.error);
                    }

                })
        } catch (err) {
            setLoading(false);
            setError(err.message);
        }
    }

    function handleValidateOtp(otp) {
        setLoading(true);
        try {
            let dataRow = {
                PhoneNumber: '+91' + phone,
                OTP: otp
            };
            RestServices.validatePhoneOTP(dataRow)
                .then((response) => response.json())
                .then(async (responseData) => {
                    if(responseData.status && responseData.authToken){
                        localStorage.setItem('FirebaseToken',responseData.authToken);
                        window.dispatchEvent(new Event("storage"));
                        setLoading(false);
                        history.push(ROUTES.INDEX);
                    }else{
                        setLoading(false);
                        setError(responseData.error);
                    }

                })
        } catch (err) {
            setLoading(false);
            setError(err.message);
        }
    }

    return (
        <div className={styles.content}>
            <div id="recaptcha"></div>
            <div className={styles.header}>
                <img
                    src={LOGO}
                    alt="logo"
                    data-testid="ib-webapp-logo"
                    width={`${323 * logoResize}px`}
                />
                <p
                    className={styles.navLink}
                    onClick={() => history.push('/sign-up')}
                >
                    Sign up
                </p>
            </div>
            <div className={styles.cardsWrapper}>
                <div className={styles.cards}>
                    <img
                        className={styles.charts}
                        src={CHARTS}
                        alt="charts"
                        data-testid="charts-gif"
                    />
                    {!renderOtpScreen ? (
                        <Phone
                            loading={loading}
                            error={error}
                            onSubmit={handleGetOtp}
                        />
                    ) : (
                        <Otp phone={phone} loading={loading} error={error} otpSuccess={otpSuccess} reSendOTP={handleGetOtp} onSubmit={handleValidateOtp} />
                    )}
                </div>
            </div>
        </div>
    );
}

export default withRouter(Content);
